import { z } from 'zod'

export const SchoolDirectoryEntrySchema = z.object({
  codeUai: z.string(),
  name: z.string(),
  city: z.string(),
  zipCode: z.string(),
  address: z.string().nullable(),
  department: z.string().nullable(),
  schoolDistrict: z.string().nullable(),
  contactEmail: z.string().nullable()
})

export type SchoolDirectoryEntryEntity = z.infer<typeof SchoolDirectoryEntrySchema>